// extracted by mini-css-extract-plugin
module.exports = {"root":"w82mUqgc6a2K0M49Pguf","checkbox":"daWvJcymAy9Bxjk80VNf","list":"kX9JG0_fRvEeXISffudo"};